import { DespatchTask } from "Models/despatch.task";

import { EmptyFunction, ValueOf } from "../../../../../types";
import { TaskStatus } from "../../../../../util/enums";
import { DiaryType } from "../../../../../components/DiaryCalendar";

export interface DiarySeeTasksProps {
  viewMode: DiaryType;
}
export interface DiarySeeTasksHandles {
  open: (tasks: DespatchTask[], dateSelected?: Date) => void;
  close: EmptyFunction;
}

export interface RenderBadgeArgs {
  title: string;
  values: string[];
  boxBadgeWidth: number;
  boxContainerMax: number;
  className: string;
}

type TaskContentEditFieldPermissions = {
  leader?: boolean;
  staffs?: boolean;
  fleets?: boolean;
  storageBoxes?: boolean;
};
export interface SeeTaskContentProps {
  task: DespatchTask;
  wrapLines?: boolean;
  canEdit?: boolean;
  onEdit?: (value: DespatchTask) => void;
  editPermission?: TaskContentEditFieldPermissions;
}

interface DiarySeeProps {
  viewMode: DiaryType;
  onCloseModal: EmptyFunction;
}

export interface DiarySeeOneProps extends DiarySeeProps {
  task: DespatchTask;
}

export interface DiarySeeOnePopupProps extends DiarySeeOneProps {
  isOpen: boolean;
  onClose?: () => void;
}

export interface DiarySeeManyProps extends DiarySeeProps {
  isOpen: boolean;
  tasks: DespatchTask[];
  daySelected: Date | null;
  onChangeToOneTask: (task: DespatchTask) => void;
}

export const isTaskAvailableCancel = (taskStatus?: string) => {
  if (!taskStatus) return false;

  return ([TaskStatus.REGISTERED, TaskStatus.WAITING_PUBLISH] as string[]).includes(taskStatus);
};

export interface TaskContentViewField {
  key: "orderReference" | "customer" | "tag" | "taskType" | "time";
  label: string;
  isMany: boolean;
  value?: ValueOf<DespatchTask>;
  valueLabel?: string | React.ReactNode;
}

export interface TaskContentAssignField {
  key: "storageBoxes" | "staffs" | "fleets" | "leader";
  placeholder: string;
  label: string;
  isMany: boolean;
  value?: ValueOf<DespatchTask> | DespatchTask["storageBoxes"];
  valueLabel?: string;
  options: Array<DespatchTask[keyof DespatchTask]>;
  renderLabelOption?: (labelOption: any) => string;
  onChange?: (value: any) => void;
}

export type TaskContentSections = Record<TaskContentAssignField["key"], TaskContentAssignField> &
  Record<TaskContentViewField["key"], TaskContentViewField>;

export interface TaskContentSelectFieldProps {
  field: TaskContentAssignField;
  onChangeAssign?: (value: TaskContentAssignField["value"]) => void;
}

export const attributeIsLeader = (attribute: string) => attribute === "leader";

export const compareIds = (option?: any, compare?: any) =>
  option && option.id && compare && compare.id && option.id === compare.id;
